const TYPES = {
    PAYOUT_SAVE: 'PAYOUT_SAVE',
    PAYOUT_SAVE_INFO: 'PAYOUT_SAVE_INFO',
    PAYOUT_SET_FORM: 'PAYOUT_SET_FORM',
    PAYOUT_GET: 'PAYOUT_GET',
    PAYOUT_GET_SUCCESS: 'PAYOUT_GET_SUCCESS',
    PAYOUT_SAVE_SUCCESS: 'PAYOUT_SAVE_SUCCESS',
    PAYOUT_SAVE_INFO_SUCCESS: 'PAYOUT_SAVE_INFO_SUCCESS',
    PAYOUT_SAVE_INFO_FAILED: 'PAYOUT_SAVE_INFO_FAILED',
    PAYOUT_SHOW_LOADING: 'PAYOUT_SHOW_LOADING',
    PAYOUT_HIDE_LOADING: 'PAYOUT_HIDE_LOADING',
    PAYOUT_SHOW_ERROR: 'PAYOUT_SHOW_ERROR',
    PAYOUT_HIDE_ERROR: 'PAYOUT_HIDE_ERROR',
    PAYOUT_CLEAR_ALERT: 'PAYOUT_CLEAR_ALERT'
};

export default {
    TYPES,

    showLoading: () => ({ type: TYPES.PAYOUT_SHOW_LOADING }),

    hideLoading: () => ({ type: TYPES.PAYOUT_HIDE_LOADING }),

    showError: error => ({ type: TYPES.PAYOUT_SHOW_ERROR, payload: { error } }),

    hideError: () => ({ type: TYPES.PAYOUT_HIDE_ERROR }),

    clearAlert: () => ({ type: TYPES.PAYOUT_CLEAR_ALERT }),

    save: payload => {
        return {
            type: TYPES.PAYOUT_SAVE,
            payload
        };
    },

    setForm: payload => {
        return {
            type: TYPES.PAYOUT_SET_FORM,
            payload
        };
    },

    get: payload => {
        return {
            type: TYPES.PAYOUT_GET,
            payload
        };
    },

    getSuccess: payload => {
        return {
            type: TYPES.PAYOUT_GET_SUCCESS,
            payload
        };
    },

    savePayoutInfo: payload => {
        return {
            type: TYPES.PAYOUT_SAVE_INFO,
            payload
        };
    },

    savePayoutInfoSuccess: payload => {
        return {
            type: TYPES.PAYOUT_SAVE_INFO_SUCCESS,
            payload
        };
    },

    savePayoutInfoFailed: payload => {
        return {
            type: TYPES.PAYOUT_SAVE_INFO_SUCCESS,
            payload
        };
    },

    saveSuccess: payload => {
        return {
            type: TYPES.PAYOUT_SAVE_SUCCESS,
            payload
        };
    }
};
